import { AlertNotificationIconColorless } from 'modules/sprites';
import { memo } from 'react';

import { messages } from './NotificationError.messages';
import { ImageWrapper, Root, StyledLink, TextWrapper } from './NotificationError.styles';
import { NotificationErrorProps } from './NotificationError.types';

const NotificationError = memo<NotificationErrorProps>((props) => {
    const { errorMessages } = props;

    return (
        <Root>
            <ImageWrapper>
                <AlertNotificationIconColorless />
            </ImageWrapper>

            <TextWrapper>
                {
                    <div>
                        {`${errorMessages.length === 1 ? messages.failed : messages.failedPlural}:`}

                        <ul>
                            {errorMessages.map((message) => (
                                <li key={message}>- {message}</li>
                            ))}
                        </ul>
                    </div>
                }

                <div>
                    {messages.questions({
                        contactSupportLink: <StyledLink href='#'>{messages.contactSupport}</StyledLink>,
                    })}
                </div>
            </TextWrapper>
        </Root>
    );
});

export default NotificationError;
